import { setQueriesDataFromKey } from '@pba/react-query';
import { useCallback, useMemo } from 'react';
import { useQueryClient } from '#react-query';
import { type ChatroomStatsQueryData, getChatroomStatsQueryKey } from '../use-get-chatroom-stats';

export const useUpdateChatroomStatsInCache = () => {
  const queryClient = useQueryClient();

  const adjustUnreadCount = useCallback(
    ({ difference }: { difference: number }) => {
      if (difference === 0) {
        return;
      }

      setQueriesDataFromKey<ChatroomStatsQueryData>(queryClient, getChatroomStatsQueryKey(), (data) => {
        const [statsEntry] = data ?? [];

        if (!statsEntry) {
          return data;
        }

        return [
          {
            ...statsEntry,
            unread: Math.max(statsEntry.unread + difference, 0),
          },
        ];
      });
    },
    [queryClient],
  );

  const refetchChatroomStats = useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: getChatroomStatsQueryKey() });
  }, [queryClient]);

  return useMemo(
    () => ({
      adjustUnreadCount,
      refetchChatroomStats,
    }),
    [adjustUnreadCount, refetchChatroomStats],
  );
};
